import React, { useEffect, useState } from 'react';
import {
  IonTabs,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonIcon,
  IonLabel,
  useIonViewWillEnter,
} from '@ionic/react';
import { Route, Redirect } from 'react-router-dom';

import HomeIcon from '../../../shared/assets/icons/home.svg';
import OrderIcon from '../../../shared/assets/icons/order.svg';
import MessageIcon from '../../../shared/assets/icons/message.svg';
import ReportIcon from '../../../shared/assets/icons/report.svg';
import Home from '../../../pages/home/ui/Home';
import Orders  from '../../../pages/orders/ui/Orders';
import Chat from '../../../pages/chat/ui/Chat';
import Profile from '../../../pages/profile/ui/Profile';
import { unreadChat } from '../../../entities/chat';

const MainTabs: React.FC = () => {
   const [hasChat,setHasChat] = useState<any>([])
   const newChats = async () => {
    try {
      const res = await unreadChat()
      setHasChat(res)

    } catch (error:any) {
      console.log(error)
    }
  }
  useIonViewWillEnter(()=>{
    const interval = setInterval(()=>{
      newChats()
    },30000)
  },[newChats])
  return (
    <IonTabs>
      <IonRouterOutlet>
         <Route exact path="/tabs/home">
            <Home />
          </Route>
          <Route exact path="/tabs/orders">
            <Orders/>
          </Route>
          <Route exact path="/tabs/chat">
            <Chat />
          </Route>
          <Route path="/tabs/profile">
            <Profile />
          </Route>
          {/* <Route exact path="/auth">
            <RestaurantLogin/>
          </Route> */}
          {/* <Route exact path="/">
            <Redirect to="/tab1" />
          </Route> */}

        {/* редирект на первый таб */}
        <Redirect exact from="/tabs" to="/tabs/home" />
      </IonRouterOutlet>

      <IonTabBar slot="bottom" className="pt-2 pb-3 bg-white" >
        <IonTabButton tab="home" href="/tabs/home" className="bg-[#fff]">
          <IonIcon src={HomeIcon} />
          <IonLabel className="text-[15px]">Столы</IonLabel>
        </IonTabButton>
        <IonTabButton tab="orders" href="/tabs/orders" className="bg-[#fff]">
          <IonIcon src={OrderIcon} />
          <IonLabel className="text-[15px]">Заказы</IonLabel>
        </IonTabButton>
        <IonTabButton tab="chat" href="/tabs/chat" className="bg-[#fff]">
          {hasChat.length>=1 &&  <div className='h-3 w-3 bg-red-600 rounded-full absolute top-[0px] right-[30px]'/>}
          <IonIcon src={MessageIcon} />
          <IonLabel className="text-[15px]">Чат</IonLabel>
        </IonTabButton>
        <IonTabButton tab="profile" href="/tabs/profile" className="bg-[#fff]">
          <IonIcon src={ReportIcon} />
          <IonLabel className="text-[15px]">Профиль</IonLabel>
        </IonTabButton>
      </IonTabBar>
    </IonTabs>
  );
};

export default MainTabs;
